import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useData } from '../contexts/DataContext';
import Loading from '../components/Loading';
import './BlogPost.css';

const BlogPost = () => {
  const { slug } = useParams();
  const { getBlogPostBySlug, loading } = useData();
  const post = getBlogPostBySlug(slug);

  if (loading) {
    return <Loading />;
  }

  if (!post) {
    return (
      <div className="container" style={{ padding: '100px 20px', textAlign: 'center' }}>
        <h2>Postarea nu a fost găsită</h2>
        <Link to="/blog" className="btn">Înapoi la Blog</Link>
      </div>
    );
  }

  return (
    <div className="blog-post-page">
      <div className="container">
        <Link to="/blog" className="back-link">← Înapoi la Blog</Link>

        <article className="blog-post">
          <header className="post-header">
            <h1>{post.title}</h1>
            
            <div className="post-meta">
              <span className="author">📝 Autor: {post.author}</span>
              <span className="date">
                📅 {new Date(post.published_date).toLocaleDateString('ro-RO', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </span>
            </div>

            {post.categories && post.categories.length > 0 && (
              <div className="categories">
                {post.categories.map(cat => (
                  <span key={cat.id} className="category-tag">{cat.name}</span>
                ))}
              </div>
            )}
          </header>

          {post.featured_image && (
            <div className="featured-image">
              <img src={post.featured_image} alt={post.title} />
            </div>
          )}

          <div className="post-content">
            {post.excerpt && (
              <p className="excerpt">{post.excerpt}</p>
            )}
            
            <div className="content" style={{ whiteSpace: 'pre-line' }}>
              {post.content}
            </div>
          </div>
        </article>

        <div className="post-footer">
          <Link to="/blog" className="btn">← Înapoi la Blog</Link>
        </div>
      </div>
    </div>
  );
};

export default BlogPost;











